const Loader = ({ isLoading, className: propsClass }) => {
	const className = "spinner-border text-secondary " + (propsClass || '')
	return (
		<div class={className} role="sta1tus" hidden={!isLoading} />
	)
}

export default Loader
